import { StripePaymentError } from 'shared/types/graphql';

export const STRIPE_ERROR_READABLE: Record<StripePaymentError, string> = {
  [StripePaymentError.Blocked]: 'The payment method cannot be used for payment',
  [StripePaymentError.CardNotSupported]: 'This card is not supported',
  [StripePaymentError.CurrencyNotSupported]: 'This card does not support the payment currency',
  [StripePaymentError.DuplicateTransaction]: 'The issuer identified this as a duplicate transaction',
  [StripePaymentError.ExpiredCard]: 'The card is expired',
  [StripePaymentError.Fraudulent]: 'The payment method cannot be used for payment',
  [StripePaymentError.GenericDecline]: 'The payment has failed. Please retry or have the cardholder contact the issuer',
  [StripePaymentError.IncorrectNumber]: 'The card number is incorrect',
  [StripePaymentError.IncorrectPin]: 'The PIN is incorrect',
  [StripePaymentError.IncorrectCvc]: 'The CVC is incorrect',
  [StripePaymentError.IncorrectPostalCode]: 'The postal code is incorrect',
  [StripePaymentError.InsufficientFunds]: 'The card has insufficient funds for this transaction',
  [StripePaymentError.InvalidAccount]: 'The card number is incorrect',
  [StripePaymentError.InvalidExpiry]: 'The provided expiration date is incorrect',
  [StripePaymentError.LostStolenCard]: 'The card has been reported as lost or stolen',
};
